<template>
  <div>
    <div class="hero__wrapper" :style="parallax">
      <div class="hero__content">
        <h1 class="light">Bilebändi</h1>
        <h1 class="light">Amiraali Ahtio</h1>
        <h1 class="light">& Lemmen airue</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hero",
  data() {
    return {
      parallax: {
        "background-position": "center top"
      }
    };
  },
  methods: {
    updateParallax() {
      // Lasketaan taustakuvan sijainti vierityksen perusteella
      const scrollTop = window.pageYOffset;
      this.parallax["background-position"] = `center ${-scrollTop * 0.1}px`; // Säädä kerroin (0.2) haluamallasi nopeudella
    }
  },
  mounted() {
    // Kutsutaan updateParallax-funktiota vierityksen yhteydessä
    window.addEventListener("scroll", this.updateParallax);
  },
  beforeDestroy() {
    // Poistetaan kuuntelija komponentin tuhoutuessa
    window.removeEventListener("scroll", this.updateParallax);
  }
};
</script>

<style scoped>
.hero__wrapper {
  width: 100%;
  height: 100vh;
  background: url(../assets/amiraali-gradient.jpg) no-repeat center top;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero__overlay {
  background-image: linear-gradient(to bottom right, #c37da6, #cf71a8);
  opacity: 0.5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  max-height: 100vh;
}
.hero__content {
  margin: auto;
  text-align: center;
  z-index: 3;

  background: rgba(1, 1, 1, 0);
  border-radius: 0.5rem;
  margin-top: 20vh;
  padding: 2rem;
}
h1 {
  margin: 0;
  font-size: 4rem;
}

.hero__clip {
  -webkit-clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  height: 200px;
  width: 100%;
  z-index: 2;
  position: absolute;
  background-color: white;
  bottom: 0;
}

@media (max-width: 1100px) {
  .hero__content {
    width: 65%;
  }
}
@media (max-width: 900px) {
  .hero__content {
    width: 100%;
    height: 100vh;
    margin-top: 0;
    padding-top: 25vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue